module.exports = __webpack_public_path__ + "img/kulaR.087bde03.png";